// import React, { useState, useEffect } from 'react';
// import {
//   getCoupons,
//   createCoupon,
//   updateCoupon,
//   deleteCoupon
// } from '../../Services/Operations/ProductAPI';
// import '../../Styles/ManagementPages.css';
// import { useSelector } from 'react-redux';

// const SkeletonStatsCard = () => (
//   <div className="stat-card skeleton">
//     <div className="skeleton-title"></div>
//     <div className="skeleton-value"></div>
//     <div className="skeleton-subtitle"></div>
//   </div>
// );

// const SkeletonTableRow = () => (
//   <tr className="skeleton-row">
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-badge"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-badge"></div></td>
//     <td><div className="skeleton-actions"></div></td>
//   </tr>
// );

// const SkeletonTable = () => (
//   <div className="table-container skeleton">
//     <table className="data-table">
//       <thead>
//         <tr>
//           <th>Coupon Code</th>
//           <th>Coupon Type</th>
//           <th>Discount Type</th>
//           <th>Value</th>
//           <th>Used/Limit</th>
//           <th>Valid Until</th>
//           <th>Status</th>
//           <th>Actions</th>
//         </tr>
//       </thead>
//       <tbody>
//         {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
//           <SkeletonTableRow key={i} />
//         ))}
//       </tbody>
//     </table>
//   </div>
// );

// const SkeletonModal = () => (
//   <div className="modal-overlay">
//     <div className="modal-content1 skeleton-modal">
//       <div className="modal-header">
//         <div className="skeleton-title"></div>
//         <div className="skeleton-close"></div>
//       </div>
//       <div className="modal-body">
//         {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
//           <div key={i} className="skeleton-detail-row">
//             <div className="skeleton-label"></div>
//             <div className="skeleton-value"></div>
//           </div>
//         ))}
//       </div>
//       <div className="modal-footer">
//         <div className="skeleton-button"></div>
//       </div>
//     </div>
//   </div>
// );

// const SkeletonEditModal = () => (
//   <div className="modal-overlay">
//     <div className="modal-content1 edit-modal skeleton-modal">
//       <div className="modal-header">
//         <div className="skeleton-title"></div>
//         <div className="skeleton-close"></div>
//       </div>
//       <div className="modal-body">
//         {[1, 2, 3, 4, 5, 6, 7].map((i) => (
//           <div key={i} className="form-group">
//             <div className="skeleton-label"></div>
//             <div className="skeleton-input"></div>
//           </div>
//         ))}
//       </div>
//       <div className="modal-footer">
//         <div className="skeleton-button"></div>
//         <div className="skeleton-button"></div>
//       </div>
//     </div>
//   </div>
// );

// const CouponManage = () => {
//   const [coupons, setCoupons] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searching, setSearching] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [editingCoupon, setEditingCoupon] = useState(null);
//   const [editForm, setEditForm] = useState({});
//   const [viewingCoupon, setViewingCoupon] = useState(null);
//   const [showCreateModal, setShowCreateModal] = useState(false);
//   const [newCoupon, setNewCoupon] = useState({
//     code: '',
//     type: 'Percentage',
//     value: '',
//     minAmount: '',
//     maxDiscount: '',
//     limit: '',
//     validUntil: '',
//     description: '',
//     status: 'Active',
//     couponType: 'normal'
//   });
//   const [error, setError] = useState(null);
//   const [formErrors, setFormErrors] = useState([]);
//   const { token } = useSelector(state => state.user);

//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalCoupons, setTotalCoupons] = useState(0);
//   const [pageSize] = useState(10);

//   const [filters, setFilters] = useState({
//     status: 'All Status',
//     type: 'All Types',
//     couponType: 'All Coupon Types',
//     code: '',
//     description: '',
//     minValue: '',
//     maxValue: '',
//     minUsage: '',
//     maxUsage: '',
//     validFrom: '',
//     validTo: ''
//   });
//   const [showFilters, setShowFilters] = useState(false);
//   const [isFiltered, setIsFiltered] = useState(false);

//   // ============================================================
//   // ✅ EFFECTS
//   // ============================================================

//   useEffect(() => {
//     const delayDebounceFn = setTimeout(() => {
//       fetchCoupons();
//     }, 500);

//     return () => clearTimeout(delayDebounceFn);
//   }, [currentPage, searchTerm, filters]);

//   // ============================================================
//   // ✅ UTILITY FUNCTIONS
//   // ============================================================

//   const formatDate = (dateString) => {
//     if (!dateString || dateString === 'N/A') return 'N/A';
//     const date = new Date(dateString);
//     if (isNaN(date.getTime())) return dateString;
//     const day = String(date.getDate()).padStart(2, '0');
//     const month = String(date.getMonth() + 1).padStart(2, '0');
//     const year = date.getFullYear();
//     return `${day}.${month}.${year}`;
//   };

//   const getSafeString = (value) => {
//     if (value === null || value === undefined) return '';
//     return String(value);
//   };

//   const getSafeLowerCase = (value) => {
//     if (value === null || value === undefined) return '';
//     return String(value).toLowerCase();
//   };

//   const getSafeNumber = (value) => {
//     if (value === null || value === undefined) return 0;
//     return Number(value);
//   };

//   const parseNumberInput = (value) => {
//     if (value === '' || value === null || value === undefined) return '';
//     const num = parseFloat(value);
//     return isNaN(num) ? '' : num;
//   };

//   // ============================================================
//   // ✅ VALIDATION FUNCTION
//   // ============================================================

//   const validateCoupon = (couponData) => {
//     const errors = [];

//     // Code validation
//     if (!couponData.code || couponData.code.trim() === '') {
//       errors.push('Coupon code is required');
//     } else if (couponData.code.length < 3) {
//       errors.push('Coupon code must be at least 3 characters');
//     } else if (!/^[A-Z0-9]+$/i.test(couponData.code)) {
//       errors.push('Coupon code can only contain letters and numbers');
//     }

//     // Description validation
//     if (!couponData.description || couponData.description.trim() === '') {
//       errors.push('Description is required');
//     }

//     // Valid until validation
//     if (!couponData.validUntil) {
//       errors.push('Valid until date is required');
//     } else {
//       const selectedDate = new Date(couponData.validUntil);
//       const today = new Date();
//       today.setHours(0, 0, 0, 0);
//       if (selectedDate < today) {
//         errors.push('Valid until date cannot be in the past');
//       }
//     }

//     // Normal coupon validations
//     if (couponData.couponType !== 'influencer') {
//       if (!couponData.type) {
//         errors.push('Discount type is required');
//       }

//       const value = parseFloat(couponData.value);
//       if (isNaN(value) || value <= 0) {
//         errors.push('Discount value must be greater than 0');
//       } else if (couponData.type === 'Percentage' && value > 100) {
//         errors.push('Discount percentage cannot exceed 100%');
//       }

//       // Limit validation
//       const limit = parseFloat(couponData.limit);
//       if (!isNaN(limit) && limit < 0) {
//         errors.push('Usage limit cannot be negative');
//       }
//     }

//     // Influencer coupon validations
//     if (couponData.couponType === 'influencer') {
//       const commissionRate = parseFloat(couponData.commissionRate);
//       if (isNaN(commissionRate) || commissionRate <= 0) {
//         errors.push('Commission rate must be greater than 0');
//       } else if (commissionRate > 100) {
//         errors.push('Commission rate cannot exceed 100%');
//       }
//     }

//     // Min amount validation
//     const minAmount = parseFloat(couponData.minAmount);
//     if (!isNaN(minAmount) && minAmount < 0) {
//       errors.push('Minimum amount cannot be negative');
//     }

//     return errors;
//   };

//   // ============================================================
//   // ✅ API FUNCTIONS
//   // ============================================================

//   const fetchCoupons = async () => {
//     try {
//       setSearching(true);
//       setLoading(true);
//       setError(null);

//       const filterParams = {};

//       if (searchTerm) {
//         filterParams.search = searchTerm;
//       }

//       Object.keys(filters).forEach(key => {
//         if (filters[key] && filters[key] !== 'All Status' && filters[key] !== 'All Types' && filters[key] !== 'All Coupon Types') {
//           filterParams[key] = filters[key];
//         }
//       });

//       const params = {
//         page: currentPage,
//         limit: pageSize,
//         ...filterParams
//       };

//       console.log('Fetching coupons with params:', params);

//       const response = await getCoupons(token, params);

//       if (response && response.success) {
//         const transformedCoupons = response.data.map(coupon => ({
//           id: coupon._id,
//           code: coupon.code,
//           couponType: coupon.couponType,
//           type: coupon.type,
//           value: coupon.value,
//           discountValue: coupon.type === 'Percentage' ? `${coupon.value}%` : `₹${coupon.value}`,
//           minAmount: coupon.minAmount,
//           maxDiscount: coupon.maxDiscount,
//           used: coupon.used || 0,
//           limit: coupon.limit,
//           validUntil: coupon.validUntil ? coupon.validUntil.split('T')[0] : 'N/A',
//           status: coupon.status,
//           description: coupon.description,
//           created: coupon.createdAt ? coupon.createdAt.split('T')[0] : 'N/A',
//           commissionRate: coupon.commissionRate || null,
//           influencerId: coupon.influencerId || null,
//           rawData: coupon
//         }));

//         setCoupons(transformedCoupons);

//         if (response.totalPages) {
//           setTotalPages(response.totalPages);
//         }
//         if (response.total) {
//           setTotalCoupons(response.total);
//         } else {
//           setTotalCoupons(response.data.length);
//         }

//         const hasActiveFilters =
//           filters.status !== 'All Status' ||
//           filters.type !== 'All Types' ||
//           filters.couponType !== 'All Coupon Types' ||
//           searchTerm !== '' ||
//           Object.values(filters).some(value =>
//             value && value !== '' && value !== 'All Status' && value !== 'All Types' && value !== 'All Coupon Types'
//           );
//         setIsFiltered(hasActiveFilters);
//       } else {
//         setError('Failed to fetch coupons.');
//         setCoupons([]);
//       }
//     } catch (err) {
//       console.error('Error fetching coupons:', err);
//       setError('Failed to fetch coupons. Please try again.');
//       setCoupons([]);
//     } finally {
//       setLoading(false);
//       setSearching(false);
//     }
//   };

//   // ============================================================
//   // ✅ HANDLERS - Search & Filter
//   // ============================================================

//   const handleSearchChange = (e) => {
//     setSearchTerm(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleSearchSubmit = (e) => {
//     e.preventDefault();
//     setCurrentPage(1);
//     fetchCoupons();
//   };

//   const handleFilterChange = (e) => {
//     const { name, value } = e.target;
//     setFilters(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const applyFilters = () => {
//     setCurrentPage(1);
//     fetchCoupons();
//     setShowFilters(false);
//   };

//   const clearFilters = () => {
//     setFilters({
//       status: 'All Status',
//       type: 'All Types',
//       couponType: 'All Coupon Types',
//       code: '',
//       description: '',
//       minValue: '',
//       maxValue: '',
//       minUsage: '',
//       maxUsage: '',
//       validFrom: '',
//       validTo: ''
//     });
//     setSearchTerm('');
//     setCurrentPage(1);
//     setIsFiltered(false);
//   };

//   const handleRefresh = () => {
//     setSearchTerm('');
//     setCurrentPage(1);
//     clearFilters();
//   };

//   // ============================================================
//   // ✅ HANDLERS - Export
//   // ============================================================

//   const handleExportCSV = () => {
//     if (coupons.length === 0) {
//       alert('No data to export');
//       return;
//     }

//     const headers = ['Coupon Code', 'Coupon Type', 'Discount Type', 'Value', 'Min Amount', 'Max Discount', 'Used', 'Limit', 'Valid Until', 'Status', 'Description'];
//     const csvData = coupons.map(coupon => [
//       coupon.code || '',
//       coupon.couponType || '',
//       coupon.type || '',
//       coupon.discountValue || '',
//       coupon.minAmount || 0,
//       coupon.maxDiscount || 0,
//       coupon.used || 0,
//       coupon.limit || 0,
//       coupon.validUntil || '',
//       coupon.status || '',
//       coupon.description || ''
//     ]);

//     const csvContent = [
//       headers.join(','),
//       ...csvData.map(row => row.map(field => `"${field}"`).join(','))
//     ].join('\n');

//     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//     const url = window.URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.href = url;
//     link.download = `coupons-report-${new Date().toISOString().split('T')[0]}.csv`;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     window.URL.revokeObjectURL(url);

//     alert('CSV exported successfully!');
//   };

//   // ============================================================
//   // ✅ HANDLERS - View, Edit, Delete
//   // ============================================================

//   const handleViewCoupon = (coupon) => {
//     setViewingCoupon(coupon);
//   };

//   const handleEditCoupon = (coupon) => {
//     setEditingCoupon(coupon.id);
//     setEditForm({
//       ...coupon,
//       value: coupon.value,
//       minAmount: coupon.minAmount,
//       maxDiscount: coupon.maxDiscount,
//       limit: coupon.limit
//     });
//     setFormErrors([]);
//   };

//   const handleCancelEdit = () => {
//     setEditingCoupon(null);
//     setEditForm({});
//     setError(null);
//     setFormErrors([]);
//   };

//   // ============================================================
//   // ✅ FIXED: handleInputChange with proper number handling
//   // ============================================================

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     const numericFields = ['value', 'minAmount', 'maxDiscount', 'limit', 'commissionRate'];
    
//     setEditForm(prev => ({
//       ...prev,
//       [name]: numericFields.includes(name)
//         ? value === '' ? '' : parseFloat(value)
//         : value
//     }));
    
//     // Clear validation errors when user types
//     if (formErrors.length > 0) {
//       setFormErrors([]);
//     }
//   };

//   // ============================================================
//   // ✅ FIXED: handleNewCouponChange with proper number handling
//   // ============================================================

//   const handleNewCouponChange = (e) => {
//     const { name, value } = e.target;
//     const numericFields = ['value', 'minAmount', 'maxDiscount', 'limit', 'commissionRate'];
    
//     setNewCoupon(prev => ({
//       ...prev,
//       [name]: numericFields.includes(name)
//         ? parseNumberInput(value)
//         : value
//     }));
    
//     // Clear validation errors when user types
//     if (formErrors.length > 0) {
//       setFormErrors([]);
//     }
//   };

//   // ============================================================
//   // ✅ FIXED: handleSaveEdit with validation
//   // ============================================================

//   const handleSaveEdit = async () => {
//     try {
//       setError(null);
//       setFormErrors([]);

//       // ✅ Run validation
//       const validationErrors = validateCoupon(editForm);
//       if (validationErrors.length > 0) {
//         setFormErrors(validationErrors);
//         return;
//       }

//       const { id, discountValue, created, commissionRate, influencerId, rawData, ...apiData } = editForm;

//       // ✅ Sanitize numeric fields
//       const sanitizedData = {
//         ...apiData,
//         code: apiData.code?.toUpperCase().trim() || '',
//         description: apiData.description?.trim() || '',
//         value: parseFloat(apiData.value) || 0,
//         minAmount: parseFloat(apiData.minAmount) || 0,
//         maxDiscount: parseFloat(apiData.maxDiscount) || 0,
//         limit: parseFloat(apiData.limit) || 0,
//         commissionRate: parseFloat(apiData.commissionRate) || 0,
//         validUntil: apiData.validUntil
//       };

//       const response = await updateCoupon(editingCoupon, sanitizedData, token);

//       if (response && response.success) {
//         setCoupons(prevCoupons =>
//           prevCoupons.map(coupon =>
//             coupon.id === editingCoupon ? {
//               ...editForm,
//               discountValue: editForm.type === 'Percentage' 
//                 ? `${editForm.value}%` 
//                 : `₹${editForm.value}`
//             } : coupon
//           )
//         );
//         setEditingCoupon(null);
//         setEditForm({});
//         alert('Coupon updated successfully!');
//       } else {
//         // ✅ Handle API success: false
//         const errorMsg = response?.message || 'Failed to update coupon. Please try again.';
//         setError(errorMsg);
//         alert(errorMsg);
//       }
//     } catch (err) {
//       console.error('Error updating coupon:', err);
//       const errorMsg = err.response?.data?.message || err.message || 'Failed to update coupon. Please try again.';
//       setError(errorMsg);
//       alert(errorMsg);
//     }
//   };

//   // ============================================================
//   // ✅ FIXED: handleDeleteCoupon with proper error handling
//   // ============================================================

//   const handleDeleteCoupon = async (couponId) => {
//     if (window.confirm('Are you sure you want to delete this coupon?')) {
//       try {
//         setError(null);
//         const response = await deleteCoupon(couponId, token);

//         if (response && response.success) {
//           setCoupons(prevCoupons => prevCoupons.filter(coupon => coupon.id !== couponId));
//           setTotalCoupons(prev => prev - 1);
//           alert('Coupon deleted successfully!');
//         } else {
//           const errorMsg = response?.message || 'Failed to delete coupon. Please try again.';
//           setError(errorMsg);
//           alert(errorMsg);
//         }
//       } catch (err) {
//         console.error('Error deleting coupon:', err);
//         const errorMsg = err.response?.data?.message || err.message || 'Failed to delete coupon. Please try again.';
//         setError(errorMsg);
//         alert(errorMsg);
//       }
//     }
//   };

//   // ============================================================
//   // ✅ FIXED: handleCreateCoupon with validation and else branch
//   // ============================================================

//   const handleCreateCoupon = async () => {
//     try {
//       setError(null);
//       setFormErrors([]);

//       // ✅ Run validation
//       const validationErrors = validateCoupon(newCoupon);
//       if (validationErrors.length > 0) {
//         setFormErrors(validationErrors);
//         return;
//       }

//       // ✅ Prepare API data with proper parsing
//       let apiData = {
//         code: newCoupon.code.toUpperCase().trim(),
//         description: newCoupon.description.trim(),
//         minAmount: parseFloat(newCoupon.minAmount) || 0,
//         validUntil: newCoupon.validUntil,
//         status: newCoupon.status,
//         couponType: newCoupon.couponType
//       };

//       if (newCoupon.couponType === 'influencer') {
//         apiData.commissionRate = parseFloat(newCoupon.commissionRate) || 0;
//       } else {
//         apiData.type = newCoupon.type;
//         apiData.value = parseFloat(newCoupon.value) || 0;
//         apiData.maxDiscount = parseFloat(newCoupon.maxDiscount) || 0;
//         apiData.limit = parseFloat(newCoupon.limit) || 0;
//       }

//       const response = await createCoupon(apiData, token);

//       // ✅ Handle both success and failure
//       if (response && response.success) {
//         fetchCoupons();
//         setShowCreateModal(false);
//         setNewCoupon({
//           code: '',
//           type: 'Percentage',
//           value: '',
//           minAmount: '',
//           maxDiscount: '',
//           limit: '',
//           validUntil: '',
//           description: '',
//           status: 'Active',
//           couponType: 'normal'
//         });
//         alert('Coupon created successfully!');
//       } else {
//         // ✅ Handle API success: false
//         const errorMsg = response?.message || 'Failed to create coupon. Please try again.';
//         setError(errorMsg);
//         alert(errorMsg);
//       }
//     } catch (err) {
//       console.error('Error creating coupon:', err);
//       const errorMsg = err.response?.data?.message || err.message || 'Failed to create coupon. Please try again.';
//       setError(errorMsg);
//       alert(errorMsg);
//     }
//   };

//   // ============================================================
//   // ✅ HANDLERS - Modal Controls
//   // ============================================================

//   const closeViewModal = () => {
//     setViewingCoupon(null);
//   };

//   const closeCreateModal = () => {
//     setShowCreateModal(false);
//     setNewCoupon({
//       code: '',
//       type: 'Percentage',
//       value: '',
//       minAmount: '',
//       maxDiscount: '',
//       limit: '',
//       validUntil: '',
//       description: '',
//       status: 'Active',
//       couponType: 'normal'
//     });
//     setError(null);
//     setFormErrors([]);
//   };

//   // ============================================================
//   // ✅ HANDLERS - Pagination
//   // ============================================================

//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(prev => prev + 1);
//     }
//   };

//   const handlePrevPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(prev => prev - 1);
//     }
//   };

//   const handlePageClick = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   // ============================================================
//   // ✅ COMPUTED VALUES
//   // ============================================================

//   const activeCoupons = coupons.filter(c => getSafeLowerCase(c.status) === 'active').length;
//   const normalCoupons = coupons.filter(c => getSafeLowerCase(c.couponType) === 'normal').length;
//   const influencerCoupons = coupons.filter(c => getSafeLowerCase(c.couponType) === 'influencer').length;
//   const totalUsage = coupons.reduce((sum, coupon) => sum + getSafeNumber(coupon.used), 0);

//   const generatePageNumbers = () => {
//     const pages = [];
//     const maxVisiblePages = 5;

//     if (totalPages <= maxVisiblePages) {
//       for (let i = 1; i <= totalPages; i++) {
//         pages.push(i);
//       }
//     } else {
//       let start = Math.max(1, currentPage - 2);
//       let end = Math.min(totalPages, start + maxVisiblePages - 1);

//       if (end - start + 1 < maxVisiblePages) {
//         start = Math.max(1, end - maxVisiblePages + 1);
//       }

//       for (let i = start; i <= end; i++) {
//         pages.push(i);
//       }
//     }

//     return pages;
//   };

//   // ============================================================
//   // ✅ RENDER
//   // ============================================================

//   if (loading && coupons.length === 0) {
//     return (
//       <div className="management-page">
//         <div className="page-header">
//           <div className="skeleton-header-title"></div>
//           <div className="header-actions">
//             <div className="skeleton-search"></div>
//             <div className="skeleton-button"></div>
//             <div className="skeleton-button"></div>
//             <div className="skeleton-button"></div>
//           </div>
//         </div>

//         <div className="stats-cards">
//           {[1, 2, 3, 4, 5].map((i) => (
//             <SkeletonStatsCard key={i} />
//           ))}
//         </div>

//         <SkeletonTable />

//         <div className="pagination-container">
//           <div className="skeleton-pagination-info"></div>
//           <div className="skeleton-pagination-controls"></div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="management-page">
//       <div className="page-header">
//         <h1>Coupon Management</h1>
//         <div className="header-actions">
//           <form onSubmit={handleSearchSubmit} className="search-form">
//             <div style={{ position: 'relative' }}>
//               <input
//                 type="text"
//                 placeholder="Search by coupon code..."
//                 className="search-input"
//                 value={searchTerm}
//                 onChange={handleSearchChange}
//                 style={{ width: "70%" }}
//               />
//               {searching && (
//                 <span style={{
//                   position: 'absolute', right: '10px', top: '50%',
//                   transform: 'translateY(-50%)', fontSize: '12px', color: '#888'
//                 }}>
//                   searching...
//                 </span>
//               )}
//             </div>
//           </form>

//           <button className="refresh-btn" onClick={handleRefresh}>
//             Refresh
//           </button>
//           <button className="export-btn" onClick={handleExportCSV}>
//             Export CSV
//           </button>
//           <button className="add-btn" onClick={() => setShowCreateModal(true)}>
//             + Create Coupon
//           </button>
//         </div>
//       </div>

//       {/* ============================================================
//           FILTERS
//           ============================================================ */}
//       {showFilters && (
//         <div className="filter-panel">
//           <div className="filter-header">
//             <h3>Filter Coupons</h3>
//             <button className="close-filters" onClick={() => setShowFilters(false)}>
//               ×
//             </button>
//           </div>
//           <div className="filter-grid">
//             <div className="filter-group">
//               <label>Coupon Code</label>
//               <input
//                 type="text"
//                 name="code"
//                 value={filters.code}
//                 onChange={handleFilterChange}
//                 placeholder="Enter coupon code"
//               />
//             </div>
//             <div className="filter-group">
//               <label>Description</label>
//               <input
//                 type="text"
//                 name="description"
//                 value={filters.description}
//                 onChange={handleFilterChange}
//                 placeholder="Enter description"
//               />
//             </div>
//             <div className="filter-group">
//               <label>Status</label>
//               <select
//                 name="status"
//                 value={filters.status}
//                 onChange={handleFilterChange}
//               >
//                 <option value="All Status">All Status</option>
//                 <option value="Active">Active</option>
//                 <option value="Expired">Expired</option>
//                 <option value="Inactive">Inactive</option>
//               </select>
//             </div>
//             <div className="filter-group">
//               <label>Coupon Type</label>
//               <select
//                 name="couponType"
//                 value={filters.couponType}
//                 onChange={handleFilterChange}
//               >
//                 <option value="All Coupon Types">All Types</option>
//                 <option value="normal">Normal</option>
//                 <option value="influencer">Influencer</option>
//               </select>
//             </div>
//             <div className="filter-group">
//               <label>Discount Type</label>
//               <select
//                 name="type"
//                 value={filters.type}
//                 onChange={handleFilterChange}
//               >
//                 <option value="All Types">All Types</option>
//                 <option value="Percentage">Percentage</option>
//                 <option value="Fixed">Fixed</option>
//               </select>
//             </div>
//             <div className="filter-group">
//               <label>Min Discount Value</label>
//               <input
//                 type="number"
//                 name="minValue"
//                 value={filters.minValue}
//                 onChange={handleFilterChange}
//                 placeholder="Minimum value"
//                 min="0"
//               />
//             </div>
//             <div className="filter-group">
//               <label>Max Discount Value</label>
//               <input
//                 type="number"
//                 name="maxValue"
//                 value={filters.maxValue}
//                 onChange={handleFilterChange}
//                 placeholder="Maximum value"
//                 min="0"
//               />
//             </div>
//             <div className="filter-group">
//               <label>Min Usage</label>
//               <input
//                 type="number"
//                 name="minUsage"
//                 value={filters.minUsage}
//                 onChange={handleFilterChange}
//                 placeholder="Minimum usage"
//                 min="0"
//               />
//             </div>
//             <div className="filter-group">
//               <label>Max Usage</label>
//               <input
//                 type="number"
//                 name="maxUsage"
//                 value={filters.maxUsage}
//                 onChange={handleFilterChange}
//                 placeholder="Maximum usage"
//                 min="0"
//               />
//             </div>
//             <div className="filter-group">
//               <label>Valid From</label>
//               <input
//                 type="date"
//                 name="validFrom"
//                 value={filters.validFrom}
//                 onChange={handleFilterChange}
//               />
//             </div>
//             <div className="filter-group">
//               <label>Valid To</label>
//               <input
//                 type="date"
//                 name="validTo"
//                 value={filters.validTo}
//                 onChange={handleFilterChange}
//               />
//             </div>
//           </div>
//           <div className="filter-actions">
//             <button className="apply-filters-btn" onClick={applyFilters}>
//               Apply Filters
//             </button>
//             <button className="clear-filters-btn" onClick={clearFilters}>
//               Clear All
//             </button>
//           </div>
//           {isFiltered && (
//             <div className="active-filters">
//               <span>Active Filters:</span>
//               {searchTerm && (
//                 <span className="filter-tag">Search: {searchTerm}</span>
//               )}
//               {filters.status !== 'All Status' && (
//                 <span className="filter-tag">Status: {filters.status}</span>
//               )}
//               {filters.type !== 'All Types' && (
//                 <span className="filter-tag">Discount Type: {filters.type}</span>
//               )}
//               {filters.couponType !== 'All Coupon Types' && (
//                 <span className="filter-tag">Coupon Type: {filters.couponType}</span>
//               )}
//               {Object.entries(filters).map(([key, value]) =>
//                 value &&
//                 key !== 'status' &&
//                 key !== 'type' &&
//                 key !== 'couponType' &&
//                 key !== 'validFrom' &&
//                 key !== 'validTo' && (
//                   <span key={key} className="filter-tag">
//                     {key}: {value}
//                   </span>
//                 )
//               )}
//               {filters.validFrom && (
//                 <span className="filter-tag">Valid From: {filters.validFrom}</span>
//               )}
//               {filters.validTo && (
//                 <span className="filter-tag">Valid To: {filters.validTo}</span>
//               )}
//             </div>
//           )}
//         </div>
//       )}

//       {/* ============================================================
//           ERROR DISPLAY
//           ============================================================ */}
//       {error && (
//         <div className="error-message" style={{
//           backgroundColor: '#f8d7da',
//           color: '#721c24',
//           padding: '12px 16px',
//           borderRadius: '4px',
//           marginBottom: '16px',
//           border: '1px solid #f5c6cb'
//         }}>
//           {error}
//         </div>
//       )}

//       {/* ============================================================
//           STATS CARDS
//           ============================================================ */}
//       <div className="stats-cards">
//         <div className="stat-card">
//           <h3>Total Coupons</h3>
//           <p>{totalCoupons}</p>
//           <span>All coupons</span>
//         </div>
//         <div className="stat-card">
//           <h3>Active Coupons</h3>
//           <p>{activeCoupons}</p>
//           <span>Active coupons</span>
//         </div>
//         <div className="stat-card">
//           <h3>Normal Coupons</h3>
//           <p>{normalCoupons}</p>
//           <span>Normal coupons</span>
//         </div>
//         <div className="stat-card">
//           <h3>Influencer Coupons</h3>
//           <p>{influencerCoupons}</p>
//           <span>Influencer coupons</span>
//         </div>
//         <div className="stat-card">
//           <h3>Total Usage</h3>
//           <p>{totalUsage}</p>
//           <span>Total coupon uses</span>
//         </div>
//       </div>

//       {/* ============================================================
//           TABLE
//           ============================================================ */}
//       <div className="table-container">
//         <table className="data-table">
//           <thead>
//             <tr>
//               <th>Coupon Code</th>
//               <th>Coupon Type</th>
//               <th>Discount Type</th>
//               <th>Value</th>
//               <th>Used/Limit</th>
//               <th>Valid Until</th>
//               <th>Status</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {coupons.length > 0 ? (
//               coupons.map(coupon => (
//                 <tr key={coupon.id}>
//                   <td className="coupon-code">{getSafeString(coupon.code)}</td>
//                   <td>
//                     <span className={`coupon-type-badge ${getSafeLowerCase(coupon.couponType)}`}>
//                       {coupon.couponType ? coupon.couponType.charAt(0).toUpperCase() + coupon.couponType.slice(1) : 'Normal'}
//                     </span>
//                   </td>
//                   <td>
//                     {editingCoupon === coupon.id ? (
//                       <select
//                         name="type"
//                         value={editForm.type || ''}
//                         onChange={handleInputChange}
//                         className="edit-select"
//                       >
//                         <option value="Percentage">Percentage</option>
//                         <option value="Fixed">Fixed</option>
//                       </select>
//                     ) : (
//                       getSafeString(coupon.type)
//                     )}
//                   </td>
//                   <td>
//                     {editingCoupon === coupon.id ? (
//                       <input
//                         type="number"
//                         name="value"
//                         value={editForm.value || ''}
//                         onChange={handleInputChange}
//                         className="edit-input"
//                         placeholder={editForm.type === 'Percentage' ? 'Percentage' : 'Amount'}
//                       />
//                     ) : (
//                       getSafeString(coupon.discountValue)
//                     )}
//                   </td>
//                   <td>
//                     <div className="usage-info">
//                       <span className="used-count">{getSafeNumber(coupon.used)}</span>
//                       <span className="usage-separator">/</span>
//                       <span className="limit-count">{getSafeNumber(coupon.limit)}</span>
//                     </div>
//                     {editingCoupon === coupon.id && (
//                       <input
//                         type="number"
//                         name="limit"
//                         value={editForm.limit || ''}
//                         onChange={handleInputChange}
//                         className="edit-input small"
//                         placeholder="Limit"
//                       />
//                     )}
//                   </td>
//                   <td>
//                     {editingCoupon === coupon.id ? (
//                       <input
//                         type="date"
//                         name="validUntil"
//                         value={editForm.validUntil || ''}
//                         onChange={handleInputChange}
//                         className="edit-input"
//                       />
//                     ) : (
//                       formatDate(coupon.validUntil)
//                     )}
//                   </td>
//                   <td>
//                     {editingCoupon === coupon.id ? (
//                       <select
//                         name="status"
//                         value={editForm.status || ''}
//                         onChange={handleInputChange}
//                         className="edit-select"
//                       >
//                         <option value="Active">Active</option>
//                         <option value="Expired">Expired</option>
//                         <option value="Inactive">Inactive</option>
//                       </select>
//                     ) : (
//                       <span className={`status-badge ${getSafeLowerCase(coupon.status)}`}>
//                         {getSafeString(coupon.status)}
//                       </span>
//                     )}
//                   </td>
//                   <td>
//                     {editingCoupon === coupon.id ? (
//                       <div className="edit-actions">
//                         <button className="action-btn save" onClick={handleSaveEdit}>
//                           Save
//                         </button>
//                         <button className="action-btn cancel" onClick={handleCancelEdit}>
//                           Cancel
//                         </button>
//                       </div>
//                     ) : (
//                       <div className="action-buttons">
//                         <button
//                           className="action-btn view"
//                           onClick={() => handleViewCoupon(coupon)}
//                         >
//                           View
//                         </button>
//                         <button
//                           className="action-btn edit"
//                           onClick={() => handleEditCoupon(coupon)}
//                         >
//                           Edit
//                         </button>
//                         <button
//                           className="action-btn delete"
//                           onClick={() => handleDeleteCoupon(coupon.id)}
//                         >
//                           Delete
//                         </button>
//                       </div>
//                     )}
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="8" className="no-data">
//                   <p>No coupons found {isFiltered ? 'matching your filters' : ''}.</p>
//                   {isFiltered && (
//                     <button className="clear-filters-link" onClick={clearFilters}>
//                       Clear filters to see all coupons
//                     </button>
//                   )}
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* ============================================================
//           PAGINATION
//           ============================================================ */}
//       <div className="pagination-container">
//         <div className="pagination-info">
//           Showing {coupons.length} of {totalCoupons} coupons
//           (Page {currentPage} of {totalPages})
//           {searchTerm && <span className="filtered-indicator"> • Search: "{searchTerm}"</span>}
//           {isFiltered && !searchTerm && <span className="filtered-indicator"> • Filtered Results</span>}
//         </div>
//         <div className="pagination-controls">
//           <button
//             className="pagination-btn"
//             onClick={handlePrevPage}
//             disabled={currentPage === 1}
//           >
//             Previous
//           </button>

//           <div className="page-numbers">
//             {generatePageNumbers().map(pageNumber => (
//               <button
//                 key={pageNumber}
//                 className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
//                 onClick={() => handlePageClick(pageNumber)}
//               >
//                 {pageNumber}
//               </button>
//             ))}

//             {totalPages > 5 && currentPage < totalPages - 2 && (
//               <>
//                 <span className="page-dots">...</span>
//                 <button
//                   className="page-number"
//                   onClick={() => handlePageClick(totalPages)}
//                 >
//                   {totalPages}
//                 </button>
//               </>
//             )}
//           </div>

//           <button
//             className="pagination-btn"
//             onClick={handleNextPage}
//             disabled={currentPage === totalPages}
//           >
//             Next
//           </button>
//         </div>
//       </div>

//       {/* ============================================================
//           VIEW MODAL
//           ============================================================ */}
//       {viewingCoupon && (
//         <div className="modal-overlay" onClick={closeViewModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Coupon Details - {getSafeString(viewingCoupon.code)}</h3>
//               <button className="modal-close-btn" onClick={closeViewModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="customer-details">
//                 <div className="detail-row">
//                   <label>Coupon Code:</label>
//                   <span className="coupon-code">{getSafeString(viewingCoupon.code)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Coupon Type:</label>
//                   <span className={`coupon-type-badge ${getSafeLowerCase(viewingCoupon.couponType)}`}>
//                     {getSafeString(viewingCoupon.couponType)}
//                   </span>
//                   {viewingCoupon.couponType === 'influencer' && viewingCoupon.commissionRate && (
//                     <span className="commission-info">({viewingCoupon.commissionRate}% commission)</span>
//                   )}
//                 </div>
//                 <div className="detail-row">
//                   <label>Description:</label>
//                   <span>{getSafeString(viewingCoupon.description)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Discount Type:</label>
//                   <span>{getSafeString(viewingCoupon.type)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Discount Value:</label>
//                   <span>{getSafeString(viewingCoupon.discountValue)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Minimum Amount:</label>
//                   <span>₹{getSafeNumber(viewingCoupon.minAmount)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Maximum Discount:</label>
//                   <span>₹{getSafeNumber(viewingCoupon.maxDiscount)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Usage:</label>
//                   <span>{getSafeNumber(viewingCoupon.used)} / {getSafeNumber(viewingCoupon.limit)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Remaining Uses:</label>
//                   <span>{getSafeNumber(viewingCoupon.limit - viewingCoupon.used)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Valid Until:</label>
//                   <span>{formatDate(viewingCoupon.validUntil)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Status:</label>
//                   <span className={`status-badge ${getSafeLowerCase(viewingCoupon.status)}`}>
//                     {getSafeString(viewingCoupon.status)}
//                   </span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Created On:</label>
//                   <span>{formatDate(viewingCoupon.created)}</span>
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="modal-close-btn secondary" onClick={closeViewModal}>
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ============================================================
//           EDIT MODAL
//           ============================================================ */}
//       {editingCoupon && (
//         <div className="modal-overlay" onClick={handleCancelEdit}>
//           <div className="modal-content1 edit-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Edit Coupon - {getSafeString(editForm.code)}</h3>
//               <button className="modal-close-btn" onClick={handleCancelEdit}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               {/* ✅ Show validation errors */}
//               {formErrors.length > 0 && (
//                 <div className="error-container" style={{
//                   backgroundColor: '#f8d7da',
//                   color: '#721c24',
//                   padding: '12px 16px',
//                   borderRadius: '4px',
//                   marginBottom: '16px',
//                   border: '1px solid #f5c6cb'
//                 }}>
//                   <strong>Please fix the following issues:</strong>
//                   <ul style={{ margin: '8px 0 0 20px', padding: 0 }}>
//                     {formErrors.map((error, index) => (
//                       <li key={index}>{error}</li>
//                     ))}
//                   </ul>
//                 </div>
//               )}
//               <div className="edit-form">
//                 <div className="form-group">
//                   <label>Coupon Code:</label>
//                   <input
//                     type="text"
//                     name="code"
//                     value={editForm.code || ''}
//                     onChange={handleInputChange}
//                     className="form-control"
//                     placeholder="Coupon Code"
//                     disabled
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Description:</label>
//                   <input
//                     type="text"
//                     name="description"
//                     value={editForm.description || ''}
//                     onChange={handleInputChange}
//                     className="form-control"
//                     placeholder="Description"
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Discount Type:</label>
//                   <select
//                     name="type"
//                     value={editForm.type || 'Percentage'}
//                     onChange={handleInputChange}
//                     className="form-control"
//                   >
//                     <option value="Percentage">Percentage</option>
//                     <option value="Fixed">Fixed Amount</option>
//                   </select>
//                 </div>
//                 <div className="form-group">
//                   <label>Discount Value:</label>
//                   <input
//                     type="number"
//                     name="value"
//                     value={editForm.value || ''}
//                     onChange={handleInputChange}
//                     className="form-control"
//                     placeholder={editForm.type === 'Percentage' ? 'Percentage' : 'Amount'}
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Minimum Amount:</label>
//                   <input
//                     type="number"
//                     name="minAmount"
//                     value={editForm.minAmount || ''}
//                     onChange={handleInputChange}
//                     className="form-control"
//                     placeholder="Minimum order amount"
//                   />
//                 </div>
//                 {editForm.couponType !== 'influencer' && (
//                   <>
//                     <div className="form-group">
//                       <label>Maximum Discount:</label>
//                       <input
//                         type="number"
//                         name="maxDiscount"
//                         value={editForm.maxDiscount || ''}
//                         onChange={handleInputChange}
//                         className="form-control"
//                         placeholder="Maximum discount amount"
//                       />
//                     </div>
//                     <div className="form-group">
//                       <label>Usage Limit:</label>
//                       <input
//                         type="number"
//                         name="limit"
//                         value={editForm.limit || ''}
//                         onChange={handleInputChange}
//                         className="form-control"
//                         placeholder="Total usage limit"
//                       />
//                     </div>
//                   </>
//                 )}
//                 <div className="form-group">
//                   <label>Valid Until:</label>
//                   <input
//                     type="date"
//                     name="validUntil"
//                     value={editForm.validUntil?.split('T')[0] || ''}
//                     onChange={handleInputChange}
//                     className="form-control"
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Status:</label>
//                   <select
//                     name="status"
//                     value={editForm.status || 'Active'}
//                     onChange={handleInputChange}
//                     className="form-control"
//                   >
//                     <option value="Active">Active</option>
//                     <option value="Expired">Expired</option>
//                     <option value="Inactive">Inactive</option>
//                   </select>
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="action-btn cancel" onClick={handleCancelEdit}>
//                 Cancel
//               </button>
//               <button className="action-btn save" onClick={handleSaveEdit}>
//                 Save Changes
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ============================================================
//           CREATE MODAL
//           ============================================================ */}
//       {showCreateModal && (
//         <div className="modal-overlay" onClick={closeCreateModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Create New Coupon</h3>
//               <button className="modal-close-btn" onClick={closeCreateModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               {/* ✅ Show validation errors */}
//               {formErrors.length > 0 && (
//                 <div className="error-container" style={{
//                   backgroundColor: '#f8d7da',
//                   color: '#721c24',
//                   padding: '12px 16px',
//                   borderRadius: '4px',
//                   marginBottom: '16px',
//                   border: '1px solid #f5c6cb'
//                 }}>
//                   <strong>Please fix the following issues:</strong>
//                   <ul style={{ margin: '8px 0 0 20px', padding: 0 }}>
//                     {formErrors.map((error, index) => (
//                       <li key={index}>{error}</li>
//                     ))}
//                   </ul>
//                 </div>
//               )}
//               <div className="customer-details">
//                 <div className="detail-row">
//                   <label>Coupon Type:</label>
//                   <select
//                     name="couponType"
//                     value={newCoupon.couponType}
//                     onChange={handleNewCouponChange}
//                     className="edit-select"
//                   >
//                     <option value="normal">Normal Coupon</option>
//                     <option value="influencer">Influencer Coupon</option>
//                   </select>
//                 </div>
//                 <div className="detail-row">
//                   <label>Coupon Code:</label>
//                   <input
//                     type="text"
//                     name="code"
//                     value={newCoupon.code}
//                     onChange={handleNewCouponChange}
//                     className="edit-input"
//                     placeholder="Enter coupon code"
//                     style={{ textTransform: 'uppercase' }}
//                   />
//                 </div>
//                 {newCoupon.couponType === 'influencer' && (
//                   <div className="detail-row">
//                     <label>Commission Rate (%):</label>
//                     <input
//                       type="number"
//                       name="commissionRate"
//                       value={newCoupon.commissionRate || ''}
//                       onChange={handleNewCouponChange}
//                       className="edit-input"
//                       placeholder="Commission percentage"
//                       min="0"
//                       max="100"
//                     />
//                   </div>
//                 )}
//                 <div className="detail-row">
//                   <label>Description:</label>
//                   <input
//                     type="text"
//                     name="description"
//                     value={newCoupon.description}
//                     onChange={handleNewCouponChange}
//                     className="edit-input"
//                     placeholder="Enter coupon description"
//                   />
//                 </div>
//                 {newCoupon.couponType === 'normal' && (
//                   <>
//                     <div className="detail-row">
//                       <label>Discount Type:</label>
//                       <select
//                         name="type"
//                         value={newCoupon.type}
//                         onChange={handleNewCouponChange}
//                         className="edit-select"
//                       >
//                         <option value="Percentage">Percentage</option>
//                         <option value="Fixed">Fixed Amount</option>
//                       </select>
//                     </div>
//                     <div className="detail-row">
//                       <label>Discount Value:</label>
//                       <input
//                         type="number"
//                         name="value"
//                         value={newCoupon.value}
//                         onChange={handleNewCouponChange}
//                         className="edit-input"
//                         placeholder={newCoupon.type === 'Percentage' ? 'Percentage' : 'Amount'}
//                       />
//                     </div>
//                   </>
//                 )}
//                 <div className="detail-row">
//                   <label>Minimum Amount:</label>
//                   <input
//                     type="number"
//                     name="minAmount"
//                     value={newCoupon.minAmount}
//                     onChange={handleNewCouponChange}
//                     className="edit-input"
//                     placeholder="Minimum order amount"
//                   />
//                 </div>
//                 {newCoupon.couponType !== 'influencer' && (
//                   <>
//                     <div className="detail-row">
//                       <label>Maximum Discount:</label>
//                       <input
//                         type="number"
//                         name="maxDiscount"
//                         value={newCoupon.maxDiscount}
//                         onChange={handleNewCouponChange}
//                         className="edit-input"
//                         placeholder="Maximum discount amount"
//                       />
//                     </div>
//                     <div className="detail-row">
//                       <label>Usage Limit:</label>
//                       <input
//                         type="number"
//                         name="limit"
//                         value={newCoupon.limit}
//                         onChange={handleNewCouponChange}
//                         className="edit-input"
//                         placeholder="Total usage limit"
//                       />
//                     </div>
//                   </>
//                 )}
//                 <div className="detail-row">
//                   <label>Valid Until:</label>
//                   <input
//                     type="date"
//                     name="validUntil"
//                     value={newCoupon.validUntil}
//                     onChange={handleNewCouponChange}
//                     className="edit-input"
//                   />
//                 </div>
//                 <div className="detail-row">
//                   <label>Status:</label>
//                   <select
//                     name="status"
//                     value={newCoupon.status}
//                     onChange={handleNewCouponChange}
//                     className="edit-select"
//                   >
//                     <option value="Active">Active</option>
//                     <option value="Inactive">Inactive</option>
//                   </select>
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="action-btn cancel" onClick={closeCreateModal}>
//                 Cancel
//               </button>
//               <button className="action-btn save" onClick={handleCreateCoupon}>
//                 Create Coupon
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default CouponManage;

import React, { useState, useEffect } from 'react';
import {
  getCoupons,
  createCoupon,
  updateCoupon,
  deleteCoupon
} from '../../Services/Operations/ProductAPI';
import '../../Styles/ManagementPages.css';
import { useSelector } from 'react-redux';

/* ============================================================
 * MODERN UI PRIMITIVES (mirror PrimaryRouteManage.css)
 * ============================================================ */
const ICON_PATHS = {
    route: 'M5 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4z M19 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4z M7 17h7a3 3 0 0 0 0-6h-4a3 3 0 0 1 0-6h7',
    check: 'M22 11.1V12a10 10 0 1 1-5.9-9.1 M22 4 12 14l-3-3',
    calendar: 'M8 2v4 M16 2v4 M3 10h18 M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z',
    pin: 'M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 1 1 16 0z M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
    clock: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M12 6v6l4 2',
    stop: 'M12 3v18 M5 6h11l3 3-3 3H5z',
    search: 'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16z M21 21l-4.3-4.3',
    eye: 'M2 12s4-8 10-8 10 8 10 8-4 8-10 8S2 12 2 12z M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
    trash: 'M3 6h18 M8 6V4h8v2 M6 6l1 14h10l1-14 M10 11v6 M14 11v6',
    grid: 'M3 3h7v7H3z M14 3h7v7h-7z M14 14h7v7h-7z M3 14h7v7H3z',
    list: 'M8 6h13 M8 12h13 M8 18h13 M3 6h.01 M3 12h.01 M3 18h.01',
    tag: 'M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z M7.5 7.5h.01',
    plus: 'M12 5v14 M5 12h14',
    map: 'M1 6l7-3 8 3 7-3v15l-7 3-8-3-7 3z M8 3v15 M16 6v15',
    bus: 'M5 3h14a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z M3 11h18 M7 21v-3 M17 21v-3 M7 15h.01 M17 15h.01',
    edit: 'M12 20h9 M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z',
    info: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M12 16v-4 M12 8h.01',
    refresh: 'M23 4v6h-6 M1 20v-6h6 M3.5 9a9 9 0 0 1 14.9-3.4L23 10 M1 14l4.6 4.4A9 9 0 0 0 20.5 15',
    x: 'M18 6 6 18 M6 6l12 12'
};

const Icon = ({ name, size = 18 }) => (
    <svg className="prm-ico" viewBox="0 0 24 24" width={size} height={size} fill="none"
        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d={ICON_PATHS[name]} />
    </svg>
);

const BusSvg = ({ size = 34 }) => (
    <svg viewBox="0 0 64 34" width={size} height={(size * 34) / 64} aria-hidden="true">
        <rect x="2" y="3" width="58" height="23" rx="7" fill="#f59e0b" />
        <rect x="2" y="19" width="58" height="4" fill="#d97706" />
        <rect x="8" y="8" width="8" height="8" rx="2" fill="#0b1f44" />
        <rect x="19" y="8" width="8" height="8" rx="2" fill="#0b1f44" />
        <rect x="30" y="8" width="8" height="8" rx="2" fill="#0b1f44" />
        <path d="M43 8h10a4 4 0 0 1 4 4v4H43z" fill="#0b1f44" />
        <rect x="57" y="20" width="4" height="3" rx="1" fill="#fff7d6" />
        <circle cx="17" cy="27" r="5.5" fill="#0b1f44" /><circle cx="17" cy="27" r="2.2" fill="#cbd5e1" />
        <circle cx="46" cy="27" r="5.5" fill="#0b1f44" /><circle cx="46" cy="27" r="2.2" fill="#cbd5e1" />
    </svg>
);

const useCountUp = (target, duration = 900) => {
    const [value, setValue] = useState(0);
    useEffect(() => {
        let raf, start;
        const step = (t) => {
            if (!start) start = t;
            const p = Math.min((t - start) / duration, 1);
            setValue(Math.round(target * (1 - Math.pow(1 - p, 3))));
            if (p < 1) raf = requestAnimationFrame(step);
        };
        raf = requestAnimationFrame(step);
        return () => cancelAnimationFrame(raf);
    }, [target, duration]);
    return value;
};

const StatCard = ({ icon, label, value, hint, tone, delay = 0 }) => {
    const shown = useCountUp(value);
    return (
        <div className={`prm-stat tone-${tone}`} style={{ animationDelay: `${delay}ms` }}>
            <div className="prm-stat-icon"><Icon name={icon} size={24} /></div>
            <div className="prm-stat-body">
                <div className="prm-stat-label">{label}</div>
                <div className="prm-stat-value">{shown}</div>
                <div className="prm-stat-hint">{hint}</div>
            </div>
        </div>
    );
};

const Switch = ({ checked, onChange, title }) => (
    <label className="prm-switch" title={title}>
        <input type="checkbox" checked={checked} onChange={onChange} />
        <span />
    </label>
);

const FormSection = ({ n, title, hint, children, delay = 0 }) => (
    <section className="prm-fsec" style={{ animationDelay: `${delay}ms` }}>
        <header className="prm-fsec-head">
            <span className="prm-fsec-num">{n}</span>
            <div>
                <h4>{title}</h4>
                {hint && <p>{hint}</p>}
            </div>
        </header>
        <div className="prm-fsec-body">{children}</div>
    </section>
);

const Field = ({ label, required, children, full, note }) => (
    <div className={`prm-field ${full ? 'full' : ''}`}>
        {label && <label className="prm-label">{label}{required && <em>*</em>}</label>}
        {children}
        {note && <small className="prm-note">{note}</small>}
    </div>
);

const PrmCheckbox = ({ label, checked, onChange }) => (
    <label className={`prm-check ${checked ? 'on' : ''}`}>
        <input type="checkbox" checked={checked} onChange={onChange} />
        <span className="box"><Icon name="check" size={12} /></span>
        <span className="txt">{label}</span>
    </label>
);

const SkeletonStatsCard = () => (
  <div className="stat-card skeleton">
    <div className="skeleton-title"></div>
    <div className="skeleton-value"></div>
    <div className="skeleton-subtitle"></div>
  </div>
);

const SkeletonTableRow = () => (
  <tr className="skeleton-row">
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-badge"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-badge"></div></td>
    <td><div className="skeleton-actions"></div></td>
  </tr>
);

const SkeletonTable = () => (
  <div className="table-container skeleton">
    <table className="data-table">
      <thead>
        <tr>
          <th>Coupon Code</th>
          <th>Coupon Type</th>
          <th>Discount Type</th>
          <th>Value</th>
          <th>Used/Limit</th>
          <th>Valid Until</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
          <SkeletonTableRow key={i} />
        ))}
      </tbody>
    </table>
  </div>
);

const SkeletonModal = () => (
  <div className="modal-overlay">
    <div className="modal-content1 skeleton-modal">
      <div className="modal-header">
        <div className="skeleton-title"></div>
        <div className="skeleton-close"></div>
      </div>
      <div className="modal-body">
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
          <div key={i} className="skeleton-detail-row">
            <div className="skeleton-label"></div>
            <div className="skeleton-value"></div>
          </div>
        ))}
      </div>
      <div className="modal-footer">
        <div className="skeleton-button"></div>
      </div>
    </div>
  </div>
);

const SkeletonEditModal = () => (
  <div className="modal-overlay">
    <div className="modal-content1 edit-modal skeleton-modal">
      <div className="modal-header">
        <div className="skeleton-title"></div>
        <div className="skeleton-close"></div>
      </div>
      <div className="modal-body">
        {[1, 2, 3, 4, 5, 6, 7].map((i) => (
          <div key={i} className="form-group">
            <div className="skeleton-label"></div>
            <div className="skeleton-input"></div>
          </div>
        ))}
      </div>
      <div className="modal-footer">
        <div className="skeleton-button"></div>
        <div className="skeleton-button"></div>
      </div>
    </div>
  </div>
);

const CouponManage = () => {
  const [coupons, setCoupons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searching, setSearching] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [editingCoupon, setEditingCoupon] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [viewingCoupon, setViewingCoupon] = useState(null);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [newCoupon, setNewCoupon] = useState({
    code: '',
    type: 'Percentage',
    value: '',
    minAmount: '',
    maxDiscount: '',
    limit: '',
    validUntil: '',
    description: '',
    status: 'Active',
    couponType: 'normal'
  });
  const [error, setError] = useState(null);
  const [formErrors, setFormErrors] = useState([]);
  const { token } = useSelector(state => state.user);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCoupons, setTotalCoupons] = useState(0);
  const [pageSize] = useState(10);

  const [filters, setFilters] = useState({
    status: 'All Status',
    type: 'All Types',
    couponType: 'All Coupon Types',
    code: '',
    description: '',
    minValue: '',
    maxValue: '',
    minUsage: '',
    maxUsage: '',
    validFrom: '',
    validTo: ''
  });
  const [showFilters, setShowFilters] = useState(false);
  const [isFiltered, setIsFiltered] = useState(false);

  // ============================================================
  // ✅ EFFECTS
  // ============================================================

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchCoupons();
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [currentPage, searchTerm, filters]);

  // ============================================================
  // ✅ UTILITY FUNCTIONS
  // ============================================================

  const formatDate = (dateString) => {
    if (!dateString || dateString === 'N/A') return 'N/A';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  };

  const getSafeString = (value) => {
    if (value === null || value === undefined) return '';
    return String(value);
  };

  const getSafeLowerCase = (value) => {
    if (value === null || value === undefined) return '';
    return String(value).toLowerCase();
  };

  const getSafeNumber = (value) => {
    if (value === null || value === undefined) return 0;
    return Number(value);
  };

  const parseNumberInput = (value) => {
    if (value === '' || value === null || value === undefined) return '';
    const num = parseFloat(value);
    return isNaN(num) ? '' : num;
  };

  // ============================================================
  // ✅ VALIDATION FUNCTION
  // ============================================================

  const validateCoupon = (couponData) => {
    const errors = [];

    // Code validation
    if (!couponData.code || couponData.code.trim() === '') {
      errors.push('Coupon code is required');
    } else if (couponData.code.length < 3) {
      errors.push('Coupon code must be at least 3 characters');
    } else if (!/^[A-Z0-9]+$/i.test(couponData.code)) {
      errors.push('Coupon code can only contain letters and numbers');
    }

    // Description validation
    if (!couponData.description || couponData.description.trim() === '') {
      errors.push('Description is required');
    }

    // Valid until validation
    if (!couponData.validUntil) {
      errors.push('Valid until date is required');
    } else {
      const selectedDate = new Date(couponData.validUntil);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      if (selectedDate < today) {
        errors.push('Valid until date cannot be in the past');
      }
    }

    // Normal coupon validations
    if (couponData.couponType !== 'influencer') {
      if (!couponData.type) {
        errors.push('Discount type is required');
      }

      const value = parseFloat(couponData.value);
      if (isNaN(value) || value <= 0) {
        errors.push('Discount value must be greater than 0');
      } else if (couponData.type === 'Percentage' && value > 100) {
        errors.push('Discount percentage cannot exceed 100%');
      }

      // Limit validation
      const limit = parseFloat(couponData.limit);
      if (!isNaN(limit) && limit < 0) {
        errors.push('Usage limit cannot be negative');
      }
    }

    // Influencer coupon validations
    if (couponData.couponType === 'influencer') {
      const commissionRate = parseFloat(couponData.commissionRate);
      if (isNaN(commissionRate) || commissionRate <= 0) {
        errors.push('Commission rate must be greater than 0');
      } else if (commissionRate > 100) {
        errors.push('Commission rate cannot exceed 100%');
      }
    }

    // Min amount validation
    const minAmount = parseFloat(couponData.minAmount);
    if (!isNaN(minAmount) && minAmount < 0) {
      errors.push('Minimum amount cannot be negative');
    }

    return errors;
  };

  // ============================================================
  // ✅ API FUNCTIONS
  // ============================================================

  const fetchCoupons = async () => {
    try {
      setSearching(true);
      setLoading(true);
      setError(null);

      const filterParams = {};

      if (searchTerm) {
        filterParams.search = searchTerm;
      }

      Object.keys(filters).forEach(key => {
        if (filters[key] && filters[key] !== 'All Status' && filters[key] !== 'All Types' && filters[key] !== 'All Coupon Types') {
          filterParams[key] = filters[key];
        }
      });

      const params = {
        page: currentPage,
        limit: pageSize,
        ...filterParams
      };

      console.log('Fetching coupons with params:', params);

      const response = await getCoupons(token, params);

      if (response && response.success) {
        const transformedCoupons = response.data.map(coupon => ({
          id: coupon._id,
          code: coupon.code,
          couponType: coupon.couponType,
          type: coupon.type,
          value: coupon.value,
          discountValue: coupon.type === 'Percentage' ? `${coupon.value}%` : `₹${coupon.value}`,
          minAmount: coupon.minAmount,
          maxDiscount: coupon.maxDiscount,
          used: coupon.used || 0,
          limit: coupon.limit,
          validUntil: coupon.validUntil ? coupon.validUntil.split('T')[0] : 'N/A',
          status: coupon.status,
          description: coupon.description,
          created: coupon.createdAt ? coupon.createdAt.split('T')[0] : 'N/A',
          commissionRate: coupon.commissionRate || null,
          influencerId: coupon.influencerId || null,
          rawData: coupon
        }));

        setCoupons(transformedCoupons);

        if (response.totalPages) {
          setTotalPages(response.totalPages);
        }
        if (response.total) {
          setTotalCoupons(response.total);
        } else {
          setTotalCoupons(response.data.length);
        }

        const hasActiveFilters =
          filters.status !== 'All Status' ||
          filters.type !== 'All Types' ||
          filters.couponType !== 'All Coupon Types' ||
          searchTerm !== '' ||
          Object.values(filters).some(value =>
            value && value !== '' && value !== 'All Status' && value !== 'All Types' && value !== 'All Coupon Types'
          );
        setIsFiltered(hasActiveFilters);
      } else {
        setError('Failed to fetch coupons.');
        setCoupons([]);
      }
    } catch (err) {
      console.error('Error fetching coupons:', err);
      setError('Failed to fetch coupons. Please try again.');
      setCoupons([]);
    } finally {
      setLoading(false);
      setSearching(false);
    }
  };

  // ============================================================
  // ✅ HANDLERS - Search & Filter
  // ============================================================

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setCurrentPage(1);
    fetchCoupons();
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const applyFilters = () => {
    setCurrentPage(1);
    fetchCoupons();
    setShowFilters(false);
  };

  const clearFilters = () => {
    setFilters({
      status: 'All Status',
      type: 'All Types',
      couponType: 'All Coupon Types',
      code: '',
      description: '',
      minValue: '',
      maxValue: '',
      minUsage: '',
      maxUsage: '',
      validFrom: '',
      validTo: ''
    });
    setSearchTerm('');
    setCurrentPage(1);
    setIsFiltered(false);
  };

  const handleRefresh = () => {
    setSearchTerm('');
    setCurrentPage(1);
    clearFilters();
  };

  // ============================================================
  // ✅ HANDLERS - Export
  // ============================================================

  const handleExportCSV = () => {
    if (coupons.length === 0) {
      alert('No data to export');
      return;
    }

    const headers = ['Coupon Code', 'Coupon Type', 'Discount Type', 'Value', 'Min Amount', 'Max Discount', 'Used', 'Limit', 'Valid Until', 'Status', 'Description'];
    const csvData = coupons.map(coupon => [
      coupon.code || '',
      coupon.couponType || '',
      coupon.type || '',
      coupon.discountValue || '',
      coupon.minAmount || 0,
      coupon.maxDiscount || 0,
      coupon.used || 0,
      coupon.limit || 0,
      coupon.validUntil || '',
      coupon.status || '',
      coupon.description || ''
    ]);

    const csvContent = [
      headers.join(','),
      ...csvData.map(row => row.map(field => `"${field}"`).join(','))
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `coupons-report-${new Date().toISOString().split('T')[0]}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    alert('CSV exported successfully!');
  };

  // ============================================================
  // ✅ HANDLERS - View, Edit, Delete
  // ============================================================

  const handleViewCoupon = (coupon) => {
    setViewingCoupon(coupon);
  };

  const handleEditCoupon = (coupon) => {
    setEditingCoupon(coupon.id);
    setEditForm({
      ...coupon,
      value: coupon.value,
      minAmount: coupon.minAmount,
      maxDiscount: coupon.maxDiscount,
      limit: coupon.limit
    });
    setFormErrors([]);
  };

  const handleCancelEdit = () => {
    setEditingCoupon(null);
    setEditForm({});
    setError(null);
    setFormErrors([]);
  };

  // ============================================================
  // ✅ FIXED: handleInputChange with proper number handling
  // ============================================================

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const numericFields = ['value', 'minAmount', 'maxDiscount', 'limit', 'commissionRate'];
    
    setEditForm(prev => ({
      ...prev,
      [name]: numericFields.includes(name)
        ? value === '' ? '' : parseFloat(value)
        : value
    }));
    
    // Clear validation errors when user types
    if (formErrors.length > 0) {
      setFormErrors([]);
    }
  };

  // ============================================================
  // ✅ FIXED: handleNewCouponChange with proper number handling
  // ============================================================

  const handleNewCouponChange = (e) => {
    const { name, value } = e.target;
    const numericFields = ['value', 'minAmount', 'maxDiscount', 'limit', 'commissionRate'];
    
    setNewCoupon(prev => ({
      ...prev,
      [name]: numericFields.includes(name)
        ? parseNumberInput(value)
        : value
    }));
    
    // Clear validation errors when user types
    if (formErrors.length > 0) {
      setFormErrors([]);
    }
  };

  // ============================================================
  // ✅ FIXED: handleSaveEdit with validation
  // ============================================================

  const handleSaveEdit = async () => {
    try {
      setError(null);
      setFormErrors([]);

      // ✅ Run validation
      const validationErrors = validateCoupon(editForm);
      if (validationErrors.length > 0) {
        setFormErrors(validationErrors);
        return;
      }

      const { id, discountValue, created, commissionRate, influencerId, rawData, ...apiData } = editForm;

      // ✅ Sanitize numeric fields
      const sanitizedData = {
        ...apiData,
        code: apiData.code?.toUpperCase().trim() || '',
        description: apiData.description?.trim() || '',
        value: parseFloat(apiData.value) || 0,
        minAmount: parseFloat(apiData.minAmount) || 0,
        maxDiscount: parseFloat(apiData.maxDiscount) || 0,
        limit: parseFloat(apiData.limit) || 0,
        commissionRate: parseFloat(apiData.commissionRate) || 0,
        validUntil: apiData.validUntil
      };

      const response = await updateCoupon(editingCoupon, sanitizedData, token);

      if (response && response.success) {
        setCoupons(prevCoupons =>
          prevCoupons.map(coupon =>
            coupon.id === editingCoupon ? {
              ...editForm,
              discountValue: editForm.type === 'Percentage' 
                ? `${editForm.value}%` 
                : `₹${editForm.value}`
            } : coupon
          )
        );
        setEditingCoupon(null);
        setEditForm({});
        alert('Coupon updated successfully!');
      } else {
        // ✅ Handle API success: false
        const errorMsg = response?.message || 'Failed to update coupon. Please try again.';
        setError(errorMsg);
        alert(errorMsg);
      }
    } catch (err) {
      console.error('Error updating coupon:', err);
      const errorMsg = err.response?.data?.message || err.message || 'Failed to update coupon. Please try again.';
      setError(errorMsg);
      alert(errorMsg);
    }
  };

  // ============================================================
  // ✅ FIXED: handleDeleteCoupon with proper error handling
  // ============================================================

  const handleDeleteCoupon = async (couponId) => {
    if (window.confirm('Are you sure you want to delete this coupon?')) {
      try {
        setError(null);
        const response = await deleteCoupon(couponId, token);

        if (response && response.success) {
          setCoupons(prevCoupons => prevCoupons.filter(coupon => coupon.id !== couponId));
          setTotalCoupons(prev => prev - 1);
          alert('Coupon deleted successfully!');
        } else {
          const errorMsg = response?.message || 'Failed to delete coupon. Please try again.';
          setError(errorMsg);
          alert(errorMsg);
        }
      } catch (err) {
        console.error('Error deleting coupon:', err);
        const errorMsg = err.response?.data?.message || err.message || 'Failed to delete coupon. Please try again.';
        setError(errorMsg);
        alert(errorMsg);
      }
    }
  };

  // ============================================================
  // ✅ FIXED: handleCreateCoupon with validation and else branch
  // ============================================================

  const handleCreateCoupon = async () => {
    try {
      setError(null);
      setFormErrors([]);

      // ✅ Run validation
      const validationErrors = validateCoupon(newCoupon);
      if (validationErrors.length > 0) {
        setFormErrors(validationErrors);
        return;
      }

      // ✅ Prepare API data with proper parsing
      let apiData = {
        code: newCoupon.code.toUpperCase().trim(),
        description: newCoupon.description.trim(),
        minAmount: parseFloat(newCoupon.minAmount) || 0,
        validUntil: newCoupon.validUntil,
        status: newCoupon.status,
        couponType: newCoupon.couponType
      };

      if (newCoupon.couponType === 'influencer') {
        apiData.commissionRate = parseFloat(newCoupon.commissionRate) || 0;
      } else {
        apiData.type = newCoupon.type;
        apiData.value = parseFloat(newCoupon.value) || 0;
        apiData.maxDiscount = parseFloat(newCoupon.maxDiscount) || 0;
        apiData.limit = parseFloat(newCoupon.limit) || 0;
      }

      const response = await createCoupon(apiData, token);

      // ✅ Handle both success and failure
      if (response && response.success) {
        fetchCoupons();
        setShowCreateModal(false);
        setNewCoupon({
          code: '',
          type: 'Percentage',
          value: '',
          minAmount: '',
          maxDiscount: '',
          limit: '',
          validUntil: '',
          description: '',
          status: 'Active',
          couponType: 'normal'
        });
        alert('Coupon created successfully!');
      } else {
        // ✅ Handle API success: false
        const errorMsg = response?.message || 'Failed to create coupon. Please try again.';
        setError(errorMsg);
        alert(errorMsg);
      }
    } catch (err) {
      console.error('Error creating coupon:', err);
      const errorMsg = err.response?.data?.message || err.message || 'Failed to create coupon. Please try again.';
      setError(errorMsg);
      alert(errorMsg);
    }
  };

  // ============================================================
  // ✅ HANDLERS - Modal Controls
  // ============================================================

  const closeViewModal = () => {
    setViewingCoupon(null);
  };

  const closeCreateModal = () => {
    setShowCreateModal(false);
    setNewCoupon({
      code: '',
      type: 'Percentage',
      value: '',
      minAmount: '',
      maxDiscount: '',
      limit: '',
      validUntil: '',
      description: '',
      status: 'Active',
      couponType: 'normal'
    });
    setError(null);
    setFormErrors([]);
  };

  // ============================================================
  // ✅ HANDLERS - Pagination
  // ============================================================

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prev => prev + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(prev => prev - 1);
    }
  };

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // ============================================================
  // ✅ COMPUTED VALUES
  // ============================================================

  const activeCoupons = coupons.filter(c => getSafeLowerCase(c.status) === 'active').length;
  const normalCoupons = coupons.filter(c => getSafeLowerCase(c.couponType) === 'normal').length;
  const influencerCoupons = coupons.filter(c => getSafeLowerCase(c.couponType) === 'influencer').length;
  const totalUsage = coupons.reduce((sum, coupon) => sum + getSafeNumber(coupon.used), 0);

  const generatePageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      let start = Math.max(1, currentPage - 2);
      let end = Math.min(totalPages, start + maxVisiblePages - 1);

      if (end - start + 1 < maxVisiblePages) {
        start = Math.max(1, end - maxVisiblePages + 1);
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
    }

    return pages;
  };

  // ============================================================
  // ✅ RENDER
  // ============================================================

  if (loading && coupons.length === 0) {
    return (
      <div className="management-page">
        <div className="page-header">
          <div className="skeleton-header-title"></div>
          <div className="header-actions">
            <div className="skeleton-search"></div>
            <div className="skeleton-button"></div>
            <div className="skeleton-button"></div>
            <div className="skeleton-button"></div>
          </div>
        </div>

        <div className="stats-cards">
          {[1, 2, 3, 4, 5].map((i) => (
            <SkeletonStatsCard key={i} />
          ))}
        </div>

        <SkeletonTable />

        <div className="pagination-container">
          <div className="skeleton-pagination-info"></div>
          <div className="skeleton-pagination-controls"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="prm-page">
      {/* ============================== HERO ============================== */}
      <div className="prm-hero">
        <div className="prm-hero-road" aria-hidden="true">
          <span className="prm-hero-roadbus"><BusSvg size={46} /></span>
        </div>
        <div className="prm-hero-text">
          <span className="prm-eyebrow"><Icon name="tag" size={13} /> Discount Insights</span>
          <h1>Coupon Management</h1>
          <p>Create and manage coupon codes, discount rules and influencer commission programs.</p>
        </div>
        <div className="prm-hero-actions">
          <form onSubmit={handleSearchSubmit} style={{ margin: 0 }}>
            <div className="prm-search">
              <Icon name="search" size={17} />
              <input
                type="text"
                placeholder="Search by coupon code…"
                value={searchTerm}
                onChange={handleSearchChange}
              />
              {searchTerm && (
                <button type="button" className="prm-search-clear" onClick={() => { setSearchTerm(''); setCurrentPage(1); }}>×</button>
              )}
            </div>
          </form>
          <button className="prm-btn ghost" style={{ padding: '13px 16px' }} onClick={() => setShowFilters(!showFilters)} title="Filters">
            <Icon name="search" size={16} />
          </button>
          <button className="prm-btn ghost" style={{ padding: '13px 16px' }} onClick={handleRefresh} title="Refresh">
            <Icon name="refresh" size={16} />
          </button>
          <button className="prm-btn ghost" style={{ padding: '13px 16px' }} onClick={handleExportCSV} title="Export CSV">
            <Icon name="list" size={16} />
          </button>
          <button className="prm-add-btn" onClick={() => setShowCreateModal(true)}>
            <span className="plus"><Icon name="plus" size={14} /></span> Create Coupon
          </button>
        </div>
      </div>

      {error && (
        <div className="prm-callout rose" style={{ marginTop: 20, background: 'var(--rose-soft)', borderColor: 'var(--rose)', color: '#be123c' }}>
          <Icon name="info" size={18} />
          <div>
            <strong>Error</strong>
            <span>{error}</span>
          </div>
        </div>
      )}

      {/* ============================== STATS ============================== */}
      <div className="prm-stats">
        <StatCard icon="tag" tone="indigo" label="Total Coupons" value={totalCoupons} hint="All coupons" delay={80} />
        <StatCard icon="check" tone="green" label="Active Coupons" value={activeCoupons} hint="Currently active" delay={160} />
        <StatCard icon="ticket" tone="amber" label="Normal Coupons" value={normalCoupons} hint="Standard discount coupons" delay={240} />
        <StatCard icon="star" tone="cyan" label="Influencer Coupons" value={influencerCoupons} hint="Influencer commission programs" delay={320} />
        <StatCard icon="percent" tone="indigo" label="Total Usage" value={totalUsage} hint="Total coupon uses" delay={400} />
      </div>

      {/* ============================== FILTER PANEL ============================== */}
      {showFilters && (
        <div className="prm-fsec" style={{ marginBottom: 22 }}>
          <header className="prm-fsec-head">
            <span className="prm-fsec-num"><Icon name="search" size={16} /></span>
            <div style={{ flex: 1 }}>
              <h4>Filter Coupons</h4>
              <p>Refine the list by code, type, status, value, usage or validity.</p>
            </div>
            <button className="prm-modal-close" style={{ position: 'static' }} onClick={() => setShowFilters(false)}>×</button>
          </header>

          <div className="prm-fsec-body">
            <div className="prm-fgrid">
              <Field label="Coupon Code"><input type="text" name="code" value={filters.code} onChange={handleFilterChange} className="prm-input" placeholder="Enter coupon code" /></Field>
              <Field label="Description"><input type="text" name="description" value={filters.description} onChange={handleFilterChange} className="prm-input" placeholder="Enter description" /></Field>
              <Field label="Status">
                <select name="status" value={filters.status} onChange={handleFilterChange} className="prm-input prm-select">
                  <option value="All Status">All Status</option>
                  <option value="Active">Active</option>
                  <option value="Expired">Expired</option>
                  <option value="Inactive">Inactive</option>
                </select>
              </Field>
              <Field label="Coupon Type">
                <select name="couponType" value={filters.couponType} onChange={handleFilterChange} className="prm-input prm-select">
                  <option value="All Coupon Types">All Types</option>
                  <option value="normal">Normal</option>
                  <option value="influencer">Influencer</option>
                </select>
              </Field>
              <Field label="Discount Type">
                <select name="type" value={filters.type} onChange={handleFilterChange} className="prm-input prm-select">
                  <option value="All Types">All Types</option>
                  <option value="Percentage">Percentage</option>
                  <option value="Fixed">Fixed</option>
                </select>
              </Field>
              <Field label="Min Discount Value"><input type="number" name="minValue" value={filters.minValue} onChange={handleFilterChange} className="prm-input" placeholder="Minimum" min="0" /></Field>
              <Field label="Max Discount Value"><input type="number" name="maxValue" value={filters.maxValue} onChange={handleFilterChange} className="prm-input" placeholder="Maximum" min="0" /></Field>
              <Field label="Min Usage"><input type="number" name="minUsage" value={filters.minUsage} onChange={handleFilterChange} className="prm-input" placeholder="Minimum usage" min="0" /></Field>
              <Field label="Max Usage"><input type="number" name="maxUsage" value={filters.maxUsage} onChange={handleFilterChange} className="prm-input" placeholder="Maximum usage" min="0" /></Field>
              <Field label="Valid From"><input type="date" name="validFrom" value={filters.validFrom} onChange={handleFilterChange} className="prm-input" /></Field>
              <Field label="Valid To"><input type="date" name="validTo" value={filters.validTo} onChange={handleFilterChange} className="prm-input" /></Field>
            </div>

            <div style={{ display: 'flex', gap: 10, marginTop: 20, flexWrap: 'wrap' }}>
              <button className="prm-btn primary" onClick={applyFilters}>
                <Icon name="check" size={15} /> Apply Filters
              </button>
              <button className="prm-btn ghost" onClick={clearFilters}>
                <Icon name="x" size={15} /> Clear All
              </button>
            </div>

            {isFiltered && (
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 16, alignItems: 'center' }}>
                <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--muted)' }}>Active Filters:</span>
                {searchTerm && <span className="prm-tag amber">Search: {searchTerm}</span>}
                {filters.status !== 'All Status' && <span className="prm-tag amber">Status: {filters.status}</span>}
                {filters.type !== 'All Types' && <span className="prm-tag amber">Discount Type: {filters.type}</span>}
                {filters.couponType !== 'All Coupon Types' && <span className="prm-tag amber">Coupon Type: {filters.couponType}</span>}
                {Object.entries(filters).map(([key, value]) =>
                  value && key !== 'status' && key !== 'type' && key !== 'couponType' && key !== 'validFrom' && key !== 'validTo' && (
                    <span key={key} className="prm-tag amber">{key}: {value}</span>
                  )
                )}
                {filters.validFrom && <span className="prm-tag amber">From: {filters.validFrom}</span>}
                {filters.validTo && <span className="prm-tag amber">To: {filters.validTo}</span>}
              </div>
            )}
          </div>
        </div>
      )}

      {/* ============================== TOOLBAR ============================== */}
      <div className="prm-toolbar">
        <div className="prm-toolbar-left">
          <span className="prm-tag navy"><Icon name="tag" size={12} /> Coupon Codes</span>
          {isFiltered && <span className="prm-tag amber">Filtered</span>}
        </div>
        <div className="prm-toolbar-right">
          <span className="prm-result-count">Showing <b>{coupons.length}</b> of {totalCoupons}</span>
          {searching && <span style={{ color: 'var(--amber-deep)', fontSize: 12 }}>· searching…</span>}
        </div>
      </div>

      {/* ============================== TABLE ============================== */}
      {coupons.length === 0 ? (
        <div className="prm-empty">
          <div className="icon"><Icon name={isFiltered ? 'search' : 'tag'} size={44} /></div>
          <h3>{isFiltered ? 'No coupons match your filters' : 'No coupons yet'}</h3>
          <p>{isFiltered ? 'Try adjusting your filters or clear them to see all coupons.' : 'Create your first coupon to get started.'}</p>
          {isFiltered && <button className="prm-btn ghost" onClick={clearFilters}>Clear filters</button>}
        </div>
      ) : (
        <div className="prm-table-wrap">
          <table className="prm-table">
            <thead>
              <tr>
                <th>Coupon Code</th>
                <th>Coupon Type</th>
                <th>Discount Type</th>
                <th>Value</th>
                <th>Used / Limit</th>
                <th>Valid Until</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {coupons.map((coupon, i) => (
                <tr key={coupon.id} style={{ animationDelay: `${i * 40}ms` }}>
                  <td><span className="pbo-plate">{getSafeString(coupon.code)}</span></td>
                  <td>
                    <span className="prm-tag" style={{
                      background: getSafeLowerCase(coupon.couponType) === 'influencer' ? 'var(--amber-soft)' : 'var(--blue-soft)',
                      color: getSafeLowerCase(coupon.couponType) === 'influencer' ? 'var(--amber-deep)' : 'var(--navy-800)'
                    }}>
                      {coupon.couponType ? coupon.couponType.charAt(0).toUpperCase() + coupon.couponType.slice(1) : 'Normal'}
                    </span>
                  </td>
                  <td>
                    {editingCoupon === coupon.id ? (
                      <select name="type" value={editForm.type || ''} onChange={handleInputChange} className="prm-input prm-select" style={{ padding: '6px 8px', fontSize: 12 }}>
                        <option value="Percentage">Percentage</option>
                        <option value="Fixed">Fixed</option>
                      </select>
                    ) : getSafeString(coupon.type)}
                  </td>
                  <td>
                    {editingCoupon === coupon.id ? (
                      <input type="number" name="value" value={editForm.value || ''} onChange={handleInputChange} className="prm-input" style={{ padding: '6px 8px', fontSize: 13, width: 100 }} />
                    ) : <b>{getSafeString(coupon.discountValue)}</b>}
                  </td>
                  <td>
                    <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                      <span className="prm-tag teal">{getSafeNumber(coupon.used)}</span>
                      <span style={{ color: 'var(--muted)' }}>/</span>
                      <span className="prm-tag navy">{getSafeNumber(coupon.limit)}</span>
                    </div>
                    {editingCoupon === coupon.id && (
                      <input type="number" name="limit" value={editForm.limit || ''} onChange={handleInputChange} className="prm-input" placeholder="Limit" style={{ padding: '6px 8px', fontSize: 12, width: 100, marginTop: 6 }} />
                    )}
                  </td>
                  <td>
                    {editingCoupon === coupon.id ? (
                      <input type="date" name="validUntil" value={editForm.validUntil || ''} onChange={handleInputChange} className="prm-input" style={{ padding: '6px 8px', fontSize: 12 }} />
                    ) : formatDate(coupon.validUntil)}
                  </td>
                  <td>
                    {editingCoupon === coupon.id ? (
                      <select name="status" value={editForm.status || ''} onChange={handleInputChange} className="prm-input prm-select" style={{ padding: '6px 8px', fontSize: 12 }}>
                        <option value="Active">Active</option>
                        <option value="Expired">Expired</option>
                        <option value="Inactive">Inactive</option>
                      </select>
                    ) : (
                      <span className={`prm-status ${getSafeLowerCase(coupon.status)}`}>{getSafeString(coupon.status)}</span>
                    )}
                  </td>
                  <td>
                    {editingCoupon === coupon.id ? (
                      <div className="prm-row-actions">
                        <button className="prm-btn primary sm icon-only" onClick={handleSaveEdit} title="Save" aria-label="Save"><Icon name="check" size={14} /></button>
                        <button className="prm-btn ghost sm icon-only" onClick={handleCancelEdit} title="Cancel" aria-label="Cancel"><Icon name="x" size={14} /></button>
                      </div>
                    ) : (
                      <div className="prm-row-actions">
                        <button className="prm-btn view sm icon-only" onClick={() => handleViewCoupon(coupon)} title="View" aria-label="View"><Icon name="eye" size={14} /></button>
                        <button className="prm-btn ghost sm icon-only" onClick={() => handleEditCoupon(coupon)} title="Edit" aria-label="Edit"><Icon name="edit" size={14} /></button>
                        <button className="prm-btn danger sm icon-only" onClick={() => handleDeleteCoupon(coupon.id)} title="Delete" aria-label="Delete"><Icon name="trash" size={14} /></button>
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* ============================== PAGINATION ============================== */}
      {totalPages > 1 && (
        <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginTop: 22, flexWrap: 'wrap' }}>
          <button className="prm-btn ghost" onClick={handlePrevPage} disabled={currentPage === 1}>Previous</button>
          <span style={{ padding: '11px 16px', fontWeight: 700, color: 'var(--navy-800)' }}>
            Page {currentPage} of {totalPages}
          </span>
          <button className="prm-btn ghost" onClick={handleNextPage} disabled={currentPage === totalPages}>Next</button>
        </div>
      )}

      {/* ============================================================
       * VIEW MODAL — Modern redesign
       * ============================================================ */}
      {viewingCoupon && (
        <div className="prm-overlay" onClick={closeViewModal}>
          <div className="prm-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 720 }}>
            <div className="prm-modal-head">
              <h3>Coupon Details — {getSafeString(viewingCoupon.code)}</h3>
              <p><Icon name="tag" size={14} /> {getSafeString(viewingCoupon.couponType === 'influencer' ? 'Influencer' : 'Normal')} · {getSafeString(viewingCoupon.discountValue)}</p>
              <button className="prm-modal-close" onClick={closeViewModal}>×</button>
            </div>

            <div className="prm-modal-body">
              <div className="prm-info-grid">
                <div className="prm-info"><div className="l">Code</div><div className="v">{getSafeString(viewingCoupon.code)}</div></div>
                <div className="prm-info"><div className="l">Status</div><div className="v"><span className={`prm-status ${getSafeLowerCase(viewingCoupon.status)}`}>{getSafeString(viewingCoupon.status)}</span></div></div>
                <div className="prm-info"><div className="l">Discount</div><div className="v">{getSafeString(viewingCoupon.discountValue)}</div></div>
                <div className="prm-info"><div className="l">Valid Until</div><div className="v">{formatDate(viewingCoupon.validUntil)}</div></div>
              </div>

              <div className="prm-section-title">Coupon Info</div>
              <div className="prm-info-grid" style={{ marginBottom: 22 }}>
                <div className="prm-info"><div className="l">Coupon Type</div><div className="v">{getSafeString(viewingCoupon.couponType)}</div></div>
                {viewingCoupon.couponType === 'influencer' && viewingCoupon.commissionRate && (
                  <div className="prm-info"><div className="l">Commission Rate</div><div className="v">{viewingCoupon.commissionRate}%</div></div>
                )}
                <div className="prm-info"><div className="l">Discount Type</div><div className="v">{getSafeString(viewingCoupon.type)}</div></div>
                <div className="prm-info"><div className="l">Min Amount</div><div className="v">₹{getSafeNumber(viewingCoupon.minAmount)}</div></div>
                <div className="prm-info"><div className="l">Max Discount</div><div className="v">₹{getSafeNumber(viewingCoupon.maxDiscount)}</div></div>
                <div className="prm-info"><div className="l">Used / Limit</div><div className="v">{getSafeNumber(viewingCoupon.used)} / {getSafeNumber(viewingCoupon.limit)}</div></div>
                <div className="prm-info"><div className="l">Remaining Uses</div><div className="v">{getSafeNumber(viewingCoupon.limit - viewingCoupon.used)}</div></div>
                <div className="prm-info"><div className="l">Created On</div><div className="v">{formatDate(viewingCoupon.created)}</div></div>
              </div>

              {viewingCoupon.description && (
                <>
                  <div className="prm-section-title">Description</div>
                  <div className="prm-info" style={{ marginBottom: 22 }}>
                    <div className="v" style={{ fontSize: 13, fontWeight: 500 }}>{viewingCoupon.description}</div>
                  </div>
                </>
              )}
            </div>

            <div className="prm-modal-foot">
              <button className="prm-btn primary" style={{ padding: '11px 28px' }} onClick={closeViewModal}>Close</button>
            </div>
          </div>
        </div>
      )}

      {/* ============================================================
       * EDIT MODAL — Modern redesign
       * ============================================================ */}
      {editingCoupon && (
        <div className="prm-overlay" onClick={handleCancelEdit}>
          <div className="prm-form-modal" onClick={(e) => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <span className="prm-form-badge"><Icon name="edit" size={24} /></span>
                <div>
                  <h3>Edit Coupon</h3>
                  <p>{getSafeString(editForm.code)}</p>
                </div>
              </div>
              <button className="prm-modal-close" onClick={handleCancelEdit}>×</button>
            </div>

            <div className="prm-form-body">
              {formErrors.length > 0 && (
                <div className="prm-callout rose" style={{ background: 'var(--rose-soft)', borderColor: 'var(--rose)', color: '#be123c' }}>
                  <Icon name="info" size={18} />
                  <div>
                    <strong>Please fix the following issues</strong>
                    <ul style={{ margin: '4px 0 0 18px', padding: 0 }}>
                      {formErrors.map((error, index) => <li key={index}>{error}</li>)}
                    </ul>
                  </div>
                </div>
              )}

              <FormSection n="1" title="Coupon Details" hint="Edit the coupon fields below." delay={40}>
                <div className="prm-fgrid">
                  <Field label="Coupon Code" full><input type="text" name="code" value={editForm.code || ''} onChange={handleInputChange} className="prm-input" disabled /></Field>
                  <Field label="Description" full><input type="text" name="description" value={editForm.description || ''} onChange={handleInputChange} className="prm-input" /></Field>
                  <Field label="Discount Type">
                    <select name="type" value={editForm.type || 'Percentage'} onChange={handleInputChange} className="prm-input prm-select">
                      <option value="Percentage">Percentage</option>
                      <option value="Fixed">Fixed Amount</option>
                    </select>
                  </Field>
                  <Field label="Discount Value"><input type="number" name="value" value={editForm.value || ''} onChange={handleInputChange} className="prm-input" /></Field>
                  <Field label="Minimum Amount"><input type="number" name="minAmount" value={editForm.minAmount || ''} onChange={handleInputChange} className="prm-input" /></Field>
                  {editForm.couponType !== 'influencer' && (
                    <>
                      <Field label="Maximum Discount"><input type="number" name="maxDiscount" value={editForm.maxDiscount || ''} onChange={handleInputChange} className="prm-input" /></Field>
                      <Field label="Usage Limit"><input type="number" name="limit" value={editForm.limit || ''} onChange={handleInputChange} className="prm-input" /></Field>
                    </>
                  )}
                  <Field label="Valid Until"><input type="date" name="validUntil" value={editForm.validUntil?.split('T')[0] || ''} onChange={handleInputChange} className="prm-input" /></Field>
                  <Field label="Status">
                    <select name="status" value={editForm.status || 'Active'} onChange={handleInputChange} className="prm-input prm-select">
                      <option value="Active">Active</option>
                      <option value="Expired">Expired</option>
                      <option value="Inactive">Inactive</option>
                    </select>
                  </Field>
                </div>
              </FormSection>
            </div>

            <div className="prm-form-foot">
              <span className="prm-foot-hint">Fields marked <em>*</em> are required</span>
              <div className="prm-form-foot-actions">
                <button className="prm-btn ghost" onClick={handleCancelEdit}>Cancel</button>
                <button className="prm-btn primary" onClick={handleSaveEdit}>
                  <Icon name="check" size={16} /> Save Changes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ============================================================
       * CREATE MODAL — Modern redesign
       * ============================================================ */}
      {showCreateModal && (
        <div className="prm-overlay" onClick={closeCreateModal}>
          <div className="prm-form-modal" onClick={(e) => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <span className="prm-form-badge"><Icon name="plus" size={24} /></span>
                <div>
                  <h3>Create New Coupon</h3>
                  <p>Set up discount rules and limits</p>
                </div>
              </div>
              <button className="prm-modal-close" onClick={closeCreateModal}>×</button>
            </div>

            <div className="prm-form-body">
              {formErrors.length > 0 && (
                <div className="prm-callout rose" style={{ background: 'var(--rose-soft)', borderColor: 'var(--rose)', color: '#be123c' }}>
                  <Icon name="info" size={18} />
                  <div>
                    <strong>Please fix the following issues</strong>
                    <ul style={{ margin: '4px 0 0 18px', padding: 0 }}>
                      {formErrors.map((error, index) => <li key={index}>{error}</li>)}
                    </ul>
                  </div>
                </div>
              )}

              {/* 1 — Coupon Type */}
              <FormSection n="1" title="Coupon Type" hint="Choose between a normal discount coupon or an influencer program." delay={40}>
                <div className="prm-fgrid">
                  <Field label="Coupon Type" required full>
                    <select name="couponType" value={newCoupon.couponType} onChange={handleNewCouponChange} className="prm-input prm-select">
                      <option value="normal">Normal Coupon</option>
                      <option value="influencer">Influencer Coupon</option>
                    </select>
                  </Field>
                  <Field label="Coupon Code" required full>
                    <input type="text" name="code" value={newCoupon.code} onChange={handleNewCouponChange} className="prm-input" placeholder="Enter coupon code" style={{ textTransform: 'uppercase' }} />
                  </Field>
                  <Field label="Description" required full>
                    <input type="text" name="description" value={newCoupon.description} onChange={handleNewCouponChange} className="prm-input" placeholder="Enter coupon description" />
                  </Field>
                </div>
              </FormSection>

              {/* 2 — Discount Rules */}
              <FormSection n="2" title="Discount Rules" hint="Configure value, limits and thresholds." delay={80}>
                <div className="prm-fgrid">
                  {newCoupon.couponType === 'influencer' ? (
                    <Field label="Commission Rate (%)" required full note="Percentage commission for influencer">
                      <input type="number" name="commissionRate" value={newCoupon.commissionRate || ''} onChange={handleNewCouponChange} className="prm-input" min="0" max="100" placeholder="Commission percentage" />
                    </Field>
                  ) : (
                    <>
                      <Field label="Discount Type" required>
                        <select name="type" value={newCoupon.type} onChange={handleNewCouponChange} className="prm-input prm-select">
                          <option value="Percentage">Percentage</option>
                          <option value="Fixed">Fixed Amount</option>
                        </select>
                      </Field>
                      <Field label="Discount Value" required>
                        <input type="number" name="value" value={newCoupon.value} onChange={handleNewCouponChange} className="prm-input" placeholder={newCoupon.type === 'Percentage' ? 'Percentage' : 'Amount'} />
                      </Field>
                      <Field label="Maximum Discount">
                        <input type="number" name="maxDiscount" value={newCoupon.maxDiscount} onChange={handleNewCouponChange} className="prm-input" placeholder="Maximum discount amount" />
                      </Field>
                      <Field label="Usage Limit">
                        <input type="number" name="limit" value={newCoupon.limit} onChange={handleNewCouponChange} className="prm-input" placeholder="Total usage limit" />
                      </Field>
                    </>
                  )}
                  <Field label="Minimum Amount">
                    <input type="number" name="minAmount" value={newCoupon.minAmount} onChange={handleNewCouponChange} className="prm-input" placeholder="Minimum order amount" />
                  </Field>
                </div>
              </FormSection>

              {/* 3 — Validity */}
              <FormSection n="3" title="Validity & Status" hint="Set the expiry date and initial status." delay={120}>
                <div className="prm-fgrid">
                  <Field label="Valid Until" required>
                    <input type="date" name="validUntil" value={newCoupon.validUntil} onChange={handleNewCouponChange} className="prm-input" />
                  </Field>
                  <Field label="Status">
                    <select name="status" value={newCoupon.status} onChange={handleNewCouponChange} className="prm-input prm-select">
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </select>
                  </Field>
                </div>
              </FormSection>
            </div>

            <div className="prm-form-foot">
              <span className="prm-foot-hint">Fields marked <em>*</em> are required</span>
              <div className="prm-form-foot-actions">
                <button className="prm-btn ghost" onClick={closeCreateModal}>Cancel</button>
                <button className="prm-btn primary" onClick={handleCreateCoupon}>
                  <Icon name="check" size={16} /> Create Coupon
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CouponManage;